export default __webpack_public_path__ + "static/src/companys/fubon/assets/images/backgrounds/login_bg.png";